import { getClientConfig } from '../config/getClientConfig';

/**
 * Function to get the font family based on the provided font name.
 * If the font name is not found in the theme, it defaults to 'regular'.
 *
 * @param {FontType} fontName - The name of the font to retrieve.
 * @returns {string} - The font family string.
 */
const getFontFamily = (fontName = 'regular') => {
  const { theme: defaultTheme } = getClientConfig();
  return defaultTheme.font[fontName] || defaultTheme.font.regular;
};

export default getFontFamily;
